import {
  FastLinkMenuItemModel,
  FastLinkMenuModel,
} from '../fastLinksMenu.model';

export enum FastLinksMenuTabs {
  sphere = 'sphere',
  schools = 'schools',
}

export type FastLinksMenuMobileModel = {
  hasSearch: boolean;
};

export type AccordionTitleModel = FastLinkMenuModel;

export type AccordionContentModel = {
  slug: string;
  items: FastLinkMenuItemModel[];
};
